import React, { FC } from 'react';
import { IconProps } from '.';

export const SignatureIcon: FC<IconProps> = ({ size = 24, ...props }) => {
    const sizing = { width: size, height: size };

    return (
        <svg fill="none" {...sizing} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M.97 21.04h19.515a.485.485 0 1 1 0 .97H.97v-.97Z" fill="url(#79ac5cd6)" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m3.865 7.113 12.71 12.71a.606.606 0 0 0 .429.177h3.663a.242.242 0 0 0 .242-.242v-3.663a.606.606 0 0 0-.177-.429L8.01 2.944c-.95-.949-2.431-.911-3.38.038l-.73.73c-.949.948-.985 2.451-.035 3.4Zm3.46-3.483c-.49-.489-1.52-.451-2.01.038l-.729.729c-.489.489-.536 1.53-.047 2.019L16.953 18.83c.091.09.215.142.343.142h2.585v-2.585a.485.485 0 0 0-.142-.343L7.324 3.63Z"
                fill="currentColor"
            />
            <path d="m15.266 17.167 2.797-2.797.686.686-2.797 2.797-.686-.686Z" fill="url(#2ebcf167)" />
            <defs>
                <linearGradient
                    id="79ac5cd6"
                    x1="20.97"
                    y1="21.525"
                    x2=".97"
                    y2="21.525"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset=".116" stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="2ebcf167"
                    x1="15.564"
                    y1="17.546"
                    x2="18.382"
                    y2="14.727"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="currentColor" />
                    <stop offset="1" stopColor="currentColor" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
